import { Form } from 'react-bootstrap';
import { GUEST_USER_PERMISSIONS } from '../../../config/roles';
import { useDispatch } from 'react-redux';
import * as PropTypes from 'prop-types';
import toast from 'react-hot-toast';

import { T, useTranslate } from '@tolgee/react';
import { updateInvite } from '../../../redux/slices/accounts/invites/invites';

const PermissionsRadioInputs = ({
  watch,
  register,
  error,
  setPermissionsError,
  userUpdate = false,
  uuid = null
}) => {
  const { t } = useTranslate();

  const updatePermission = (e) => {};

  return (
    <div className="pt-3">
      <h2>{t('invite.createForm.permissions')}</h2>
      {Object.keys(GUEST_USER_PERMISSIONS).map((permission) => (
        <div
          className={`d-flex gap-3 justify-content-between pt-4`}
          key={GUEST_USER_PERMISSIONS[permission].name}
        >
          <div>
            <h5>
              {t(`config.roles.${GUEST_USER_PERMISSIONS[permission].name}`)}
            </h5>
            <p className="text-gray-400 fw-semibold d-block fs-7">
              <T keyName={GUEST_USER_PERMISSIONS[permission].description} />
            </p>
          </div>
          <Form.Check
            type="switch"
            id="disabled-custom-switch"
            className="color-primary"
            {...register(GUEST_USER_PERMISSIONS[permission].key)}
            onClick={updatePermission}
            name={GUEST_USER_PERMISSIONS[permission].key}
            checked={watch(GUEST_USER_PERMISSIONS[permission].key)}
            defaultChecked={
              !userUpdate || watch(GUEST_USER_PERMISSIONS[permission].key)
            } // Set defaultChecked attribute to true
          />
        </div>
      ))}
    </div>
  );
};
PermissionsRadioInputs.propTypes = {
  watch: PropTypes.any,
  setPermissionsError: PropTypes.any,
  register: PropTypes.any,
  error: PropTypes.any,
  userUpdate: PropTypes.bool,
  uuid: PropTypes.any
};

export default PermissionsRadioInputs;
